import {
  GrippingOffsetInput,
  GrippingWidthsInput,
} from '@automata/wfb-api/src/apis/wfbApiSchemas';
import { z } from 'zod';

export type LabwareOffsetDefinition = {
  gripping_widths?: GrippingWidthsInput | null;
  gripping_depth_offset?: GrippingOffsetInput | null;
  gripping_height_offset?: number | GrippingOffsetInput | null;
} | null;

export enum DefinitionOrientation {
  PORTRAIT = 'portrait',
  LANDSCAPE = 'landscape',
}

const grippingWidthInputSchema = z.object({
  gripped: z.number().min(0).nullable().optional(),
  released: z.number().min(0).nullable().optional(),
});

const grippingWidthsInputSchema = z.object({
  portrait: grippingWidthInputSchema.nullable().optional(),
  landscape: grippingWidthInputSchema.nullable().optional(),
});

const grippingOffsetInputSchema = z.object({
  portrait: z.number().nullable().optional(),
  landscape: z.number().nullable().optional(),
});

export const labwareOffsetDefinitionSchema = z
  .object({
    gripping_widths: grippingWidthsInputSchema.nullable().optional(),
    gripping_depth_offset: grippingOffsetInputSchema.nullable().optional(),
    gripping_height_offset: z
      .union([z.number(), grippingOffsetInputSchema])
      .nullable()
      .optional(),
  })
  .partial();
